import { createFileRoute } from '@tanstack/react-router';

import { RouterContext } from '~/types/router.type';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { getRouteHead } from '~/utils/routeUtils';

import { DeliveryNoteDataQuality } from '~/components/deliveries/deliveryNoteDataQuality/DeliveryNoteDataQuality';

import { getDeliveryNote } from './-routeParams';

const title = i18n.t(($) => $.pageTitle.detail, { ns: 'delivery' });

export const Route = createFileRoute(
  '/(main)/deliveries/all/$deliveryId/data-quality',
)({
  beforeLoad: ({ context, params }) => getDeliveryNote({ context, params }),
  component: DeliveryNoteDataQuality,
  head: ({ loaderData }: { loaderData?: RouterContext }) =>
    getRouteHead(`${title} ${loaderData?.pageData?.title ?? ''}`),
  loader: ({ context }) => context,
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const DELIVERY_DATA_QUALITY = buildRouteExport({
  Route,
});
